import * as parseUrl from 'url-parse';
import { appendUnityLoginIframe } from '../utils/landing';
import { AccountView } from '../account-window/account-view';
import { executeLinkAuthMethod } from '../account-window/parts/execute-link-auth-method';
import { AuthMethod } from '../account-window/parts/auth-method';
import { container } from "../utils/container/container";
import { FeatureFlagsLoader } from "../utils/feature-flags/feature-flags-loader";
import { ServiceIds } from "../utils/container/service-ids";
import { FlagNames } from "../utils/feature-flags/flag-names";

type AppleAuthData = {
    authorization: {
        code: string;
        id_token: string;
        state: string;
    }
}
function prepareUrl(token: string): string {
    const urlObject = parseUrl(window.app.config.apple_id.redirect_uri, true);

    urlObject.set('query', {
        ...urlObject.query,
        id_token: token
    });
    return urlObject.toString();
}

export function initAppleId(): void {
    const ffLoader = container.get<FeatureFlagsLoader>(ServiceIds.FEATURE_FLAG_LOADER);
    const appleIdFlag = ffLoader.get(FlagNames.WEB_APPLE_ID_LOGIN);
    if (!appleIdFlag.isOn()) {
        return;
    }
    try {
        window.AppleID.auth.init({
            clientId: window.app.config.apple_id.client_id,
            nonce: window.app.deviceIdentifier,
            redirectURI: window.app.config.apple_id.redirect_uri,
            scope: 'email',
            state: 'Initial user authentication request',
            usePopup: true
        });
        window.app.apple_id_login = AppleIdLoginButtonHandler;
    } catch (error) {
        console.warn('appleId not initialized', error);
    }
}

function AppleIdLoginButtonHandler() {
    window.AppleID.auth.signIn().then((data: AppleAuthData) =>{
        const url = prepareUrl(data.authorization.id_token);
        appendUnityLoginIframe(url);
    });
}

export async function LinkAppleIdEventListener() {
    AccountView.showAccountLoadingState();
    initAppleId();
    const data = await window.AppleID.auth.signIn();
    return executeLinkAuthMethod(AuthMethod.APPLE_ID, {
        identity_token: data.authorization.id_token
    });
}


